import './ThreeDots.css'

import React from 'react'

const ThreeDots = (props) => {
  return (
    <>
      <div className='bouncing-loader'>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  )
}

export default ThreeDots
